import React from 'react'

import styled from 'styled-components'

import HomeIcon from '@mui/icons-material/Home';
import EmailIcon from '@mui/icons-material/Email';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import { Link } from 'react-router-dom';

import { mobile } from '../responsive'

const Container = styled.div`
    width: 100%;
    height: 88vh;
    display: flex;
    justify-content: center;
    align-items: center;

    ${mobile({ flexDirection: "column" })}
`

const Left = styled.div`
    width: 45%;
    height: 95%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    ${mobile ({ width: "100%" })}

`

const Button = styled.button`
    width: 30%;
    height: 40px;
    margin-top: 5%;
    border: 1px solid white;
    background-color: teal;
    color: white;
    border-radius: 5px;
`

const Right = styled.div`
    width: 45%;
    height: 95%;

    ${mobile ({ width: "100%" })}
`

const Top = styled.div`
    width: 100%;
    height: 50%;
`

const Bottom = styled.div`
    width: 100%;
    height: 50%;
`

const Naslov = styled.div`
    width: 100%;
    height: 30%;
    display: flex;
    align-items: center;
    justify-content: center;
`

const Informacije = styled.div`
    width: 100%;
    height: 70%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-size: 18px;
`

const ContactComponent = () => {
  return (
    <Container>
        <Left>
            <h1>Kontaktirajte nas!</h1>
            <Button><Link to="http://www.greenton.ba/kontakt/" style={{padding: "20px", color: "inherit", textDecoration: "none"}}>Kontakt</Link></Button>
        </Left>

        <Right>
            <Top>
                <Naslov>
                    <h1 style={{fontWeight: "400"}}>Kontakt informacije</h1>
                </Naslov>
                <Informacije>
                    <p><HomeIcon style={{fontSize: "20px", verticalAlign: "middle"}} /> Trg Heroja 7, Sarajevo</p>
                    <p><EmailIcon style={{fontSize: "20px", verticalAlign: "middle"}} /> info@greenton.ba</p>
                    <p><LocalPhoneIcon style={{fontSize: "20px", verticalAlign: "middle"}} /> +387 33 718 675</p>
                </Informacije>
            </Top>
            <Bottom>
                <iframe src='https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d11509.380338613133!2d18.3850815!3d43.8486757!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x67f9d4adc3a58611!2sGreenTon%20d.o.o.%20Sarajevo!5e0!3m2!1sen!2sba!4v1677942556065!5m2!1sen!2sba' style={{width: "100%", height: "100%", borderRadius: "10px", border: "none"}} title="mapa"></iframe>
            </Bottom>
        </Right>
    </Container>
  )
}

export default ContactComponent